"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_router_1 = require("react-router");
/**
 * This component allows the error list (provided via the React context) to be "registered" in external host applications
 * (outside DC3, e.g. VizPortal Client), so they can report errors into the ErrorList and have them be displayed
 * via our infrastructure.
 *
 * When this component mounts, it calls the `registerErrorStore` function with the error store from the current context.
 * The host app can then save that store in a place where it can send errors to it over time.
 *
 * When this component unmounts, in calls `unregisterErrorStore`, which signals to the host that the error store is
 * no longer valid, and that the host should stop sending errors to it.
 *
 * Errors reported to the store from the host will be added to the error list in the most immediate applicable context.
 * This component will not display the errors; that is handled separately via the `ErrorToasts` component.
 */
exports.RegisterErrorStoreInHost = react_router_1.withRouter(RegisterErrorStoreInHostComponent);
function RegisterErrorStoreInHostComponent(props) {
    var errorList = React.useContext(data_catalog_shared_1.ErrorListContext);
    var memoizedErrorStore = React.useMemo(function () { return makeErrorStore(errorList.addError); }, [errorList.addError]);
    // Register/unregister on mount/unmount
    React.useEffect(function () {
        props.registerErrorStore(memoizedErrorStore);
        return function () { return props.unregisterErrorStore(); };
    }, [props.registerErrorStore, props.unregisterErrorStore, memoizedErrorStore]);
    // Clear the error store when the URL changes, which corresponds to the rowStore/query changing
    React.useEffect(function () {
        errorList.clearErrors();
    }, [props.location]);
    return null;
}
exports.RegisterErrorStoreInHostComponent = RegisterErrorStoreInHostComponent;
function makeErrorStore(addError) {
    return {
        addError: function (error) { return addError(data_catalog_shared_1.getErrorDisplayInfo(data_catalog_shared_1.getGraphQLErrorCode(error))); },
    };
}
//# sourceMappingURL=RegisterErrorStoreInHost.js.map